export default __webpack_public_path__ + "static/media/2D_Barcode_Logo_JP_Mobile.c02242cc.svg";